export default __webpack_public_path__ + "images/6bf245c68f7dd9ee5260ec2081a59e77-hobbies.webp";